__turbopack_context__.v({
  "dropdownOptionPrice": "styles-module-scss-module__jL1QeW__dropdownOptionPrice",
  "header": "styles-module-scss-module__jL1QeW__header",
  "priceButtons": "styles-module-scss-module__jL1QeW__priceButtons",
  "priceFilter": "styles-module-scss-module__jL1QeW__priceFilter",
  "priceInput": "styles-module-scss-module__jL1QeW__priceInput",
  "rangeSlider": "styles-module-scss-module__jL1QeW__rangeSlider",
});
